import type { ReactNode } from 'react';

export const symbol_earbud_case: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M274-120q-63.52 0-108.76-45.24T120-274v-413q0-64 45.24-108.5T274-840h413q63.11 0 108.06 44.94Q840-750.11 840-687v413q0 63.52-44.5 108.76T687-120H274Zm-94-372v218q0 38.77 27.61 66.39Q235.23-180 274-180h413q39 0 66-27.61 27-27.62 27-66.39v-218H675v105q0 24.75-17.62 42.37Q639.75-327 615-327H345q-24.75 0-42.37-17.63Q285-362.25 285-387v-105H180Zm165 0v105h270v-105H345Zm-165-60h600v-135q0-38.36-27.32-65.68Q725.36-780 687-780H274q-38.77 0-66.39 27Q180-726 180-687v135Z"
		/>
	</svg>
);
